import TSPSDK from 'tsp-sdk';

const translator = new TSPSDK({
  name: 'microsite' // [required] SDK实例名称，方便识别
});

export function createTranslator() {
  return translator.create({
    locale: 'en', // [optional] 当前语言类型，默认en
    timeout: 3000, // [optional] 从tsp api获取翻译的超时时间毫秒数，默认3000
    isMainland: true, // [optional] 用户判断cdn的地址，默认会根据host来判断
    baseModules: [
      {
        name: 'listing', // [required] 模块名称
        resources: [140] // [optional] 相关的resource id列表
      }
    ]
  })
}

export default translator;

export const $t = (key) => translator.$t(key);